import { ROOT_PATH } from 'shared/consts';

interface Props {
  path: string;
  companyUuid: string;
  serviceUuid?: string;
  timeSlotUuid?: string;
  buildingUuid?: string | null;
}

export const formatPath = ({ path, companyUuid, serviceUuid = '', timeSlotUuid = '', buildingUuid }: Props): string => {
  let formattedPath = path
    .replace(':companyUuid', `${companyUuid}`)
    .replace(':serviceUuid', `${serviceUuid}`)
    .replace(':timeSlotUuid', `${timeSlotUuid}`);

  // If buildingUuid is provided and path doesn't already include it, add the prefix
  if (buildingUuid && !path.includes(':buildingUuid')) {
    // Add building prefix to the path
    formattedPath = `/building/${buildingUuid}${formattedPath}`;
  } else if (buildingUuid) {
    // Replace :buildingUuid placeholder if it exists
    formattedPath = formattedPath.replace(':buildingUuid', `${buildingUuid}`);
  }

  return formattedPath;
};

export const formatInitialPath = (pathname: string): string => {
  const formattedPathname = pathname.replace('/service-booking', '');
  return formattedPathname.includes('providers') ? formattedPathname : ROOT_PATH;
};

/**
 * Extracts buildingUuid from pathname if present
 * Expected format: /building/{buildingUuid}/...
 * @param pathname - The URL pathname
 * @returns The buildingUuid if found in path, null otherwise
 */
export const extractBuildingUuidFromPath = (pathname: string): string | null => {
  const pathnameArray = pathname.split('/');
  const buildingIndex = pathnameArray.indexOf('building');

  // Check if 'building' exists and has a UUID after it
  if (buildingIndex >= 0 && pathnameArray.length > buildingIndex + 1) {
    const potentialBuildingUuid = pathnameArray[buildingIndex + 1];
    // Allow only UUIDs - changing this would allow potential security or functionality issues
    // with malicious paths like /building/providers/...
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (uuidRegex.test(potentialBuildingUuid)) {
      return potentialBuildingUuid;
    }
  }
  return null;
};
